import { TransactionWizardContext } from "../types/transactionWizardContext";
import { TransactionWizardEvent } from "../types/TransactionWizardEvent";

export const setExchangeRateAction = (
  context: TransactionWizardContext,
  event: TransactionWizardEvent
) => {
  if (event.type !== "EXCHANGE_RATE_LOADED")
    throw new Error(`Invalid event type ${event.type}`);

  return {
    bookingValues: {
      ...context.bookingValues,
      exchangeRate: event.exchangeRate,
    },
  };
};
